import React, { useEffect, useState } from "react";
import useTransitionStore from "../../../state/transitions";
import Carousel from "./Carousel";
import { isMobile } from "react-device-detect";
import "./styled/carflip.css";
import { AnimatePresence, motion, MotionConfig } from "framer-motion";
import styled from "styled-components";
import {
  AnimateAfterDelay,
  delayBetween,
  delayInitial,
} from "../AnimateAfterDelay";
import useCustomizerStore from "../../../state/customizer";

function CarSwap() {
  const [visible, setVisible] = useState(true);
  const model = useCustomizerStore((state) => state.model);
  const setModel = useCustomizerStore((state) => state.setModel);
  const [
    setOrbitMode,
    OrbitModeActive,
    setActiveTransition,
    setDisplayMode,
    setModelInHeader,
    setCamIndex,
    setCameraSide,
    setDayMode,
    setInitialRender,
    DayMode,
    DisplayMode,
  ] = useTransitionStore(
    (s) => [
      s.setOrbitMode,
      s.OrbitModeActive,
      s.setActiveTransition,
      s.setDisplayMode,
      s.setModelInHeader,
      s.setCamIndex,
      s.setCameraSide,
      s.setDayMode,
      s.setInitialRender,
      s.DayMode,
      s.DisplayMode,
    ]
    // shallow
  );

  let delay = delayInitial;
  useEffect(() => {
    if (!visible) {
      if (DayMode === "night" || DisplayMode === "flipper") {
        setTimeout(() => {
          setVisible(true);
        }, 1500);
      }
    } else if (DayMode === "day" || DisplayMode !== "flipper") {
      setVisible(false);
    }
  }, [DayMode, DisplayMode, visible, setVisible]);

  return (
    <>
      <MotionConfig transition={{ duration: 1 }}>
        <AnimatePresence>
          {!OrbitModeActive && (
            <>
              <ButtonContainer isMobile={isMobile}>
                <AnimateAfterDelay
                  delay={(delay += delayBetween)}
                  key="car-flipper-button"
                >
                  <FlipperControls isMobile={isMobile}>
                    <button
                      className="select-trim-btn"
                      onClick={() => (
                        setOrbitMode(true),
                        setActiveTransition(true),
                        setDisplayMode("exterior"),
                        setCameraSide("passenger"),
                        setDayMode("day"),
                        setCamIndex(1),
                        setModelInHeader(true),
                        setInitialRender(true)
                      )}
                    >
                      Select Trim
                    </button>
                  </FlipperControls>
                </AnimateAfterDelay>
              </ButtonContainer>
              <Carousel />
            </>
          )}
        </AnimatePresence>
        {DisplayMode !== "interior" &&
          DisplayMode !== "powertrain" &&
          (DayMode !== "night" || DisplayMode === "flipper") && (
            <>
              <BottomGradientMask isMobile={isMobile} visible={visible} />
              <TopGradientMask isMobile={isMobile} />
            </>
          )}
      </MotionConfig>
    </>
  );
}

const ButtonContainer = styled.div`
  position: absolute;
  z-index: 910;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: ${({ isMobile }) => (isMobile ? "25%" : "20%")};
`;

const FlipperControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    border: none;
    border-radius: 999px;
    cursor: pointer;
    font-weight: 600;
    pointer-events: auto;
  }

  .select-trim-btn {
    color: #000;
    width: ${({ isMobile }) => (isMobile ? "144px" : "192px")};
    height: ${({ isMobile }) => (isMobile ? "32px" : "44px")};
    background-color: white;
    font-size: ${({ isMobile }) => (isMobile ? "12px" : "16px")};
  }

  @media (max-width: 768px) {
    width: calc(100vw - 36px);
  }
`;

const BottomGradientMask = styled.div`
  position: absolute;
  z-index: 1;
  width: 100%;
  height: ${({ isMobile, visible }) =>
    isMobile ? (visible ? "40%" : "40%") : visible ? "15%" : "35%"};
  bottom: 0;
  pointer-events: none;
  background: ${({ isMobile, visible }) =>
    isMobile
      ? visible
        ? "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 17%,rgba(0, 0, 0, 1) 100%)"
        : "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.58) 51.56%, rgba(0, 0, 0, 0.8) 100%)"
      : visible
      ? "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%,rgba(0, 0, 0, 1) 80%,rgba(0, 0, 0, 1) 100%)"
      : "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.58) 51.56%, rgba(0, 0, 0, 0.8) 100%)"};
`;

const TopGradientMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ isMobile }) => (isMobile ? "20%" : "30%")};
  width: 100%;
  z-index: 900;
  pointer-events: none;
  background: linear-gradient(0, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
`;

export default React.memo(CarSwap);
